import { CSSProperties, ReactNode, memo } from 'react';

type Sizes = 12 | 14 | 16 | 20 | 22;

const getSizeProps = (size: Sizes) => {
  switch (size) {
    case 12:
      return {
        fontSize: '12px',
        height: '14px'
      };
    case 14:
      return {
        fontSize: '14px',
        height: '14px'
      };
    case 16:
      return {
        fontSize: '16px',
        height: '14px'
      };
    case 20:
      return {
        fontSize: '20px',
        height: '19px'
      };
    case 22:
      return {
        fontSize: '22px',
        height: '26px'
      };
    default:
      return {};
  }
};

interface Props {
  children: ReactNode;
  size: Sizes;
  color?: CSSProperties['color'];
}

const Typography = ({ children, color = 'inherit', size }: Props) => {
  const sizeProps = getSizeProps(size);

  return <p style={{ margin: 0, color, lineHeight: 'initial', ...sizeProps }}>{children}</p>;
};

export default memo(Typography);
